<template>
  <div class="desktop-back-link d-none d-lg-block">
    <a v-if="useBack" href="#" class="back-link text-muted" @click.prevent="$router.back()">
      <FontAwesomeIcon icon="chevron-left" class="mr-1 chevron-icon" />
      <span>{{ label }}</span>
    </a>
    <router-link v-else :to="to" class="back-link text-muted">
      <FontAwesomeIcon icon="chevron-left" class="mr-1 chevron-icon" />
      <span>{{ label }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'DesktopBackLink',

  props: {
    to: {
      type: [String, Object],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    useBack: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.desktop-back-link {
  padding: 12px 16px 0 16px;
}

.back-link {
  text-decoration: none;
  font-size: 0.85rem;
  transition: color 0.2s ease;
}

.back-link:hover {
  color: #fff !important;
}

.chevron-icon {
  font-size: 0.7rem;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/DesktopBackLink.vue